<template>
    <form-dialog :value="value" @input="$emit('input', $event)">
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #default="{ close }">
            <SetBudgetCard :value="budget" :loading="loading">
                <template #actions="actionBindings">
                    <back-button @click="close()"></back-button>
                    <v-spacer />
                    <slot v-bind="{...actionBindings, close}"></slot>
                </template>
            </SetBudgetCard>
        </template>
    </form-dialog>
</template>

<script>
import SetBudgetCard from '@/components/Domain.Budgets/SetBudgetCard.vue';
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        budget: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    components: { SetBudgetCard }
};
</script>